import { ApproverMaintenanceModule } from "../../components/modules/ApproverMaintenance/ApproverMaintenanceModule";

function ApproverMaintenancePage({ user, isHideSideMenu }) {
  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace" />
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        <div className="MainteInfo shadow-xl bg-white rounded-lg overflow-hidden">
          {/* Header Section */}
          <div className="mainteHeader p-4 border-b">
            <div className='sub-title row text-sm'>
              <span className="text-gray-400">{"Transactions > "}</span>
              <span className="border-b border-black">{"Approver Per Maintenance"}</span>
            </div>
            <h3 className="text-xl font-bold mt-2">Approver Per Maintenance</h3>
          </div>

          {/* Header has been moved into LeaveEncashmentModule for better layout control */}
          <ApproverMaintenanceModule />
        </div>
      </div>
    </div>
  );
}

export default ApproverMaintenancePage;